import React, { useEffect, useState } from "react";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import { AngleDownIcon } from "../../../components/Icons";
import FilterData from "./FilterData";
import {
    StyledFilterHead,
    StyledCloseFilter,
    StyledFilterTitle,
    StyledHr,
    StyledOpenFilter,
    StyledFilterCell,
    StyledButtonFilterContainer,
} from "../../../styles/pages/AdministratorTach/FilterTachStyles";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";
import { useAdministratorTach } from "../../../context/AdministratorTachContext";
import {
    initialFilter,
    initialPagination,
} from "../../../context/TachContext/initialFilterData";

const { BtnPrimary, BtnOutlinePrimary } = ButtonStyles;

const FilterTach = () => {
    const [isIconActive, setIsIconActive] = useState(false);
    const { handleResetFilter, filterPage } = useFilterData();
    const { getSubprocessos, pagination, getPendingProcess } =
        useAdministratorTach();

    const handleClearFilter = () => {
        handleResetFilter(true);
        getSubprocessos(initialFilter, initialPagination);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            getPendingProcess();
        }, 60000);

        return () => {
            clearInterval(interval);
        };
    }, [filterPage]);

    return (
        <div>
            <StyledCloseFilter
                isOpen={isIconActive}
                onClick={() => {
                    setIsIconActive(!isIconActive);
                }}
            >
                <StyledFilterHead className={isIconActive ? "active" : ""}>
                    <StyledFilterTitle isOpen={isIconActive}>
                        Refine os dados usando um filtro avançado
                    </StyledFilterTitle>
                    <AngleDownIcon />
                </StyledFilterHead>
            </StyledCloseFilter>
            <StyledOpenFilter isOpen={isIconActive}>
                <StyledHr margin="0 20" />
                <div style={{ padding: "20px" }}>
                    <FilterData isGenerate={false} />
                    <StyledFilterCell>
                        <StyledButtonFilterContainer>
                            <BtnPrimary
                                style={{
                                    width: 90,
                                    marginLeft: 20,
                                    marginTop: 10,
                                }}
                                onClick={() => {
                                    getSubprocessos(filterPage, pagination);
                                }}
                            >
                                Filtrar
                            </BtnPrimary>
                            <BtnOutlinePrimary
                                style={{
                                    width: 90,
                                    marginLeft: 20,
                                    marginTop: 10,
                                }}
                                onClick={() => {
                                    handleClearFilter();
                                }}
                            >
                                Limpar
                            </BtnOutlinePrimary>
                        </StyledButtonFilterContainer>
                    </StyledFilterCell>
                </div>
            </StyledOpenFilter>
        </div>
    );
};

export default FilterTach;
